import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { KnotDivider } from "@/components/ornaments";
import { PageState } from "@/pages/PageState";

const Block = ({ text }) => {
  if (text.startsWith("## ")) return <h2 className="font-display text-2xl mt-8 mb-2">{text.slice(3)}</h2>;
  const lines = text.split("\n");
  if (lines.every((l) => l.startsWith("- "))) return <ul className="list-disc pl-6 space-y-1 my-3">{lines.map((l, i) => <li key={i}>{l.slice(2)}</li>)}</ul>;
  return <p className="my-3 leading-relaxed whitespace-pre-line">{text}</p>;
};

export const LegalBody = ({ body }) => (body || "").split(/\n\s*\n/).map((b, i) => <Block key={i} text={b.trim()} />);

export default function LegalPage() {
  const { key } = useParams();
  const [p, setP] = useState(undefined);
  useEffect(() => { setP(undefined); window.scrollTo(0, 0); api.get(`/legal/${key}`).then((r) => setP(r.data)).catch(() => setP(null)); }, [key]);
  if (!p) return <PageState loading={p === undefined} />;
  return (
    <div data-testid={`legal-page-${key}`} className="max-w-3xl mx-auto px-6 sm:px-8 py-12">
      <nav className="text-sm font-heading text-[#5e4a35] mb-8"><Link to="/" className="hover:text-[#991b1b]">Home</Link> <span className="mx-2">›</span> {p.title}</nav>
      <h1 data-testid="legal-title" className="font-display text-4xl sm:text-5xl">{p.title}</h1>
      <KnotDivider className="my-8" />
      <article data-testid="legal-body" className="vellum p-6 sm:p-10 text-[17px] text-[#2d1b0e]"><LegalBody body={p.body} /></article>
    </div>
  );
}
